import React from 'react'

import { filterByTextSearch } from './search'
import { isFunction } from './types'

export const useLazyOptions = (options, config = {}) => {
  const isLazy = isFunction(options)
  const [loading, setLoading] = React.useState(false)
  const [page, setPage] = React.useState(1)
  const [canLoadMore, setCanLoadMore] = React.useState(isLazy)
  const [localOptions, setLocalOptions] = React.useState(isLazy ? [] : options || [])
  const { limit } = config

  React.useEffect(() => {
    if (!isLazy) {
      setLocalOptions(options)
    }
  }, [options, isLazy])

  const fetchOptions = params => {
    if (isLazy) {
      setPage(1)
      setLoading(true)
      setCanLoadMore(true)
      options(params)
        ?.then(data => {
          if (!data.length || data.length < (limit || 10)) setCanLoadMore(false)
          setLocalOptions(data)
        })
        ?.finally(() => {
          setLoading(false)
        })
    } else {
      setLocalOptions(filterByTextSearch(options, params))
    }
  }

  const fetchMoreOptions = params => {
    if (!!config.disablePagination) {
      setLoading(false)
      setCanLoadMore(false)
      return
    }
    if (isLazy && !loading && !!canLoadMore) {
      setPage(page + 1)
      setLoading(true)
      options(params, page + 1)
        ?.then(data => {
          if (!data.length) setCanLoadMore(false)
          setLocalOptions([...localOptions, ...data])
        })
        ?.finally(() => {
          setLoading(false)
        })
    }
  }

  return [{ loading, localOptions, canLoadMore }, fetchOptions, fetchMoreOptions]
}
